import React from 'react';
import { ArrowLeft, FileSignature } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const SalesAgreement: React.FC = () => {
    const navigate = useNavigate();
    const { languageManager, t } = useLanguage();
    const legal = languageManager.legal;
    const { sales_agreement } = legal;

    return (
        <div className="min-h-screen bg-slate-50">
            {/* Navigation */}
            <nav className="fixed top-0 left-0 right-0 bg-white/90 backdrop-blur-md z-50 border-b border-slate-200">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-16">
                        <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate('/')}>
                            <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-primary-700 rounded-lg flex items-center justify-center overflow-hidden">
                                <img src="/sonlogo.png" alt="Lashing Calculator Logo" className="w-8 h-8 object-contain" />
                            </div>
                            <span className="text-xl font-bold gradient-text">Lashing Calculator</span>
                        </div>
                        <button
                            onClick={() => navigate('/')}
                            className="flex items-center gap-2 text-slate-600 hover:text-orange-600 transition-colors"
                        >
                            <ArrowLeft className="w-4 h-4" />
                            {legal.return_home}
                        </button>
                    </div>
                </div>
            </nav>

            <main className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
                <div className="max-w-4xl mx-auto">
                    <div className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 overflow-hidden border border-slate-100">
                        <div className="bg-gradient-to-r from-slate-900 to-slate-800 px-8 py-12 text-white">
                            <div className="flex items-center gap-4 mb-6">
                                <div className="p-3 bg-white/10 rounded-xl backdrop-blur-sm">
                                    <FileSignature className="w-8 h-8 text-orange-400" />
                                </div>
                                <h1 className="text-4xl font-bold">{sales_agreement.title}</h1>
                            </div>
                            <p className="text-slate-300 text-lg">
                                {legal.last_updated}
                            </p>
                        </div>

                        <div className="p-8 sm:p-12 space-y-12 text-slate-700 leading-relaxed">
                            <section>
                                <p className="text-lg mb-4">
                                    {sales_agreement.content}
                                </p>
                                <div className="bg-slate-50 p-6 rounded-xl border border-slate-100 mt-8">
                                    <p className="text-sm text-slate-500 italic">
                                        Note: This section is a placeholder for the full sales agreement text. Please consult with legal counsel to populate this section with compliant terms.
                                    </p>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </main>

            <footer className="bg-slate-900 text-white py-12 px-4 sm:px-6 lg:px-8">
                <div className="max-w-7xl mx-auto text-center">
                    <p className="text-slate-400">&copy; {new Date().getFullYear()} Lashing Calculator. {t('landing.features.calculations.title')}. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default SalesAgreement;
